export const getOrdersRequestParams = ({
    requiredScope,
    currentScope,
    currentWholesaler,
    currentPartner,
    currentCompany,
}) => ({
    wholesalerID: currentScope === 60 ? currentWholesaler : undefined,
    partnerID: currentScope === 40 ? currentPartner : undefined,
    companyID: currentScope === 20 ? currentCompany : undefined,
    scope: requiredScope,
    pageSize: 1000,
});
